"use client";

import { FormState, LoginFormSchema } from "./definition";
import { createSession } from "./session";
import { redirect } from "@/navigation";
import { BASE_URL } from "@/constants";

export async function checkLogin(email: string, password: string) {
  const res = await fetch(BASE_URL + "user-auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  return res.json();
}

export async function login(
  state: FormState,
  formData: FormData,
): Promise<FormState> {
  // 1. Validate form fields
  const validatedFields = LoginFormSchema.safeParse({
    email: formData.get("email"),
    password: formData.get("password"),
  });

  // If any form fields are invalid, return early
  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
    };
  }

  const data = await checkLogin(
    validatedFields.data.email,
    validatedFields.data.password,
  );
  const email = formData.get("email");
  // If userData is not found, return early
  if (data.message) {
    return { error: data.message };
  } else if (!data.user.isVerified) {
    const res = await fetch(BASE_URL + "user-auth/resend-code", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    window.location.href=`/verification?email=${email}`
    // redirect(`/verification?email=${email}`);
  } else {
    await createSession(data);
    window.location.href='/'

  }
}
